import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import "./RetailerLink.scss";

interface RetailerLinkProps {
  linkText: string;
  url: string
}

const RetailerLink = ({ linkText, url }: RetailerLinkProps) => {
  return (
    <div className="retailerLinkContainer">
      <a className="retailerLink" target="_blank" href={url} rel="noreferrer">
        {linkText} <KeyboardArrowRightIcon />{" "}
      </a>
    </div>
  );
};

export default RetailerLink;
